import { render } from "./PatientVisits.vue?vue&type=template&id=4ecbb387&scoped=true"
import script from "./PatientVisits.vue?vue&type=script&lang=js"
export * from "./PatientVisits.vue?vue&type=script&lang=js"

import "./PatientVisits.vue?vue&type=style&index=0&id=4ecbb387&scoped=true&lang=css"

import exportComponent from "C:\\work\\HIMSDeployTest\\HIMSFRONTEND\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ecbb387"]])

export default __exports__